import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, onAuthStateChanged, signInWithPopup } from "firebase/auth";
import { doc, setDoc, serverTimestamp, collection, getDocs, onSnapshot } from "firebase/firestore";
import { firebaseAuth, googleProvider } from "../firebase/firebase_configuration";
import { firebaseFirestore } from "../firebase/firebase_configuration";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../styles/authentication/signup.css"

import signupImage from "../../images/authentication/signup_image.png"
import usernameIcon from "../../images/authentication/username_icon.png"
import emailIcon from "../../images/authentication/email_icon.png"
import passwordIcon from "../../images/authentication/password_icon.png"
import googleIcon from "../../images/authentication/google_icon.png"

const Signup = () => {
    const goTo = useNavigate();
    const [getUsername, setUsername] = useState("");
    const [getEmail, setEmail] = useState("");
    const [getPassword, setPassword] = useState("");
    const [getUsernameList, setUsernameList] = useState([]);
    const [getEmailList, setEmailList] = useState([]);

    useEffect (() => {
        const isLoggedIn = onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                goTo("/main_back/home", {replace: true});
            };
        });

        return () => isLoggedIn();
    }, [goTo]);

    useEffect(() => {
        try {
            const usersRef = collection(firebaseFirestore, 'User Details');
            const unsubscribe = onSnapshot(usersRef, (docSnapshot) => {
                const usernames = [];
                const emails = [];
                docSnapshot.forEach((doc) => {
                    usernames.push(doc.data().username);
                    emails.push(doc.data().email);
                });

                setUsernameList(usernames);
                setEmailList(emails);
            });

            return () => unsubscribe();
        } catch (error) {
            console.error("Error fetching usernames:", error.message);
        };
    }, []);

    const onGoogleSignUp = async () => {
        try {
            const result = await signInWithPopup(firebaseAuth, googleProvider);
            const user = result.user;
            const userID = user.uid;
            const usersRef = collection(firebaseFirestore, 'User Details');
            const querySnapshot = await getDocs(usersRef);
            let userExists = false;

            querySnapshot.forEach((doc) => {
                if (doc.id === userID) {
                    userExists = true;
                }
            });

            if (userExists) {
                setTimeout(() => {
                    goTo("/main_back/home");
                }, 1000);
            } else {
                const username = `${user.displayName == null ? "" : user.displayName.split(" ")[0]}`;
                const email = `${user.email == null ? "" : user.email}`;
                const image = `${user.photoURL == null ? "" : user.photoURL}`;

                const userRef = doc(firebaseFirestore, 'User Details', userID);
                await setDoc(userRef, {
                    "username": username,
                    "email": email,
                    "image": image,
                    "dateCreated": serverTimestamp()
                });

                setTimeout(() => {
                    goTo("/main_back/home");
                }, 1000);
            }
        } catch (error) {
            alert(error.message);
            console.error('Error during Google sign-up:', error.message);
        };
    };

    const onLogin = () => {
        goTo("/login");
    };

    const onChangeUsername = (username) => {
        setUsername(username.target.value);
    };

    const onChangeEmail = (email) => {
        setEmail(email.target.value);
    };

    const onChangePassword = (password) => {
        setPassword(password.target.value);
    };

    const onSignup = async (form) => {
        form.preventDefault();

        if (getUsernameList.includes(getUsername)) {
            alert("An account with this username already exist. Please try another one.");
            return;
        }else if (getEmailList.includes(getEmail)) {
            alert("An account with this email address already exist. Please try another one.");
            return;
        }else {
            try {
                const signupUser = await createUserWithEmailAndPassword(firebaseAuth, getEmail, getPassword);
                const userId = signupUser.user.uid;
                try {
                    const userRef = doc(firebaseFirestore, 'User Details', userId);
                    await setDoc(userRef, {
                        "username": getUsername,
                        "email": getEmail,
                        "dateCreated": serverTimestamp()
                    });
                    
                    setTimeout(() => {
                        goTo("/main_back/home");
                    }, 1000);
                } catch (error) {
                    alert("Failed to save user details. Please try again.");
                    console.log(error.message); 
                }
            } catch (error) {
                alert("Failed to sign up. Please check your credentials and try again.");
                console.log(error.message);
            };
        };
    };

    return (
        <div className="signup_screen">
            <form method="post" onSubmit={onSignup} className="signup_left">
                <p className="signup_header">Welcome To Movinity</p>

                <p className="signup_input_label">Username</p>
                <div className="signup_input_container">
                    <img alt="username" src={usernameIcon} className="signup_input_icon_2" />
                    <input
                        className="signup_input_field" 
                        id="username"
                        placeholder="Enter your username"
                        type="name"
                        minLength={5}
                        value={getUsername}
                        onChange={onChangeUsername}
                        required
                    />
                </div>

                <p className="signup_input_label">Email Address</p>
                <div className="signup_input_container">
                    <img alt="email" src={emailIcon} className="signup_input_icon" />
                    <input
                        className="signup_input_field"
                        id="email"
                        placeholder="Enter a valid email"
                        type="email"
                        value={getEmail}
                        onChange={onChangeEmail}
                        required
                    />
                </div>

                <p className="signup_input_label">Password</p>
                <div className="signup_input_container">
                    <img alt="password" src={passwordIcon} className="signup_input_icon_2" />
                    <input
                        className="signup_input_field"
                        id="password"
                        placeholder="Enter a password"
                        type="password"
                        minLength={8}
                        value={getPassword}
                        onChange={onChangePassword}
                        required
                    />
                </div>

                <input type="submit" value={'Signup'} className="button" />

                <div className="already_container">
                    <p className="already_text">Already have an accout?</p>
                    <p className="already_link" onClick={() => onLogin()}>
                        Login
                    </p>
                </div>

                <div className="or_container">
                    <div className="or_line"></div>
                    OR
                    <div className="or_line"></div>
                </div>

                <div className="google_button" onClick={onGoogleSignUp}>
                    <img alt="Google" src={googleIcon} />
                    Signup with Google
                </div>
            </form>

            <div className="signup_right">
                <img alt="signup Wallpaper" src={signupImage} className="signupImage" />
            </div>
        </div>
    );
};

export default Signup;
